import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { HistoryMode } from './HistoryMode';

@Injectable()
export class HistoryModeHttpInterceptor implements HttpInterceptor {
  constructor(private appConfigService: AppConfigService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (typeof request.body === 'object' && request.body && 'historySearchOptions' in request.body) {
      const isHistorisiert = request.body.historySearchOptions.historisiert;
      this.appConfigService.setMode(isHistorisiert ? HistoryMode.HistoryMode.MIT_HIST : HistoryMode.HistoryMode.OHNE_HIST);
    }
    return next.handle(request);

  }
}
